import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CompLogin } from "../pages/login";
import { SesionProvider } from "./contextSesion";
import { CompGeneral } from "./rutasSeguras";
import { CompRecCont } from "../pages/recuperarContrasenia"; 
import { BottomInstrucciones } from "../componentes/btn_flotante";

import { Footer } from "../componentes/footer";

export const CompRutas = () => {
	
	const ProtectedRoute = ({ children }) => {
		const token = localStorage.getItem("camulabo_valid_session");
		if (!token) {
			return <Navigate to="/" replace />;
		} else {
			return children;
		}
	};
	const YaLogueado = ({ children }) => {
		const token = localStorage.getItem("camulabo_valid_session");
		if (token) {
			return <Navigate to="/panel" replace />;
		} else {
			return children;
		}
	};

	return (
		<div className="body">
			
			<BrowserRouter>
				<Routes>
					<Route
						path="/password/nueva"
						element={
							<YaLogueado>
								<CompRecCont />
							</YaLogueado>
						}
					/>
					<Route
						path="/"
						element={
							<YaLogueado>
								<CompLogin />
							</YaLogueado>
						}
					/>
					{/* <Route
						path="/*"
						element={
							<ProtectedRoute>
									<CompGeneral />
							</ProtectedRoute>
						}
					/>  */}
					<Route
						path="/*"
						element={
							<ProtectedRoute>
								<SesionProvider>
									<CompGeneral />
								</SesionProvider>
							</ProtectedRoute>
						}
					/> 
					{/* <Route path='/home' element={ <CompCalculadoras /> } /> */}
					{/* <Route path="*" element={<NotFound404 />} /> */}
			

				</Routes>
		
			</BrowserRouter>
			<BottomInstrucciones />
		</div>
	);
};
